export default __webpack_public_path__ + "media/images/images/gallery/32-cbde9cd7c6a4b541b856289dc5b32a40.jpg";